import B2BecLink from "@/components/B2BLink"

interface RenderCellProps {
  hasActions: boolean
  children: React.ReactNode
  to?: string
  state?: Record<string, unknown>
}

const RenderCell = ({ hasActions, children, to, state }: RenderCellProps): React.ReactNode => {
  if (!hasActions || !to) {
    return children
  }

  return (
    <B2BecLink state={state} to={to}>
      {children}
    </B2BecLink>
  )
}

export default RenderCell